export default __webpack_public_path__ + "static/media/mood-logo.72bc2f33.svg";